module.exports = __webpack_public_path__ + "media/images/category_icons/telegram_channels-9aac7f2b0146396d370ae1fa65623a93.svg";